import { useIndustryFilterOptions } from "@/store/selectors";
import { FilterOptionChip } from "../AdvizerSearchFilters";
import { ResourceConfigs } from "@/configs/resourceConfigs";
import { Group, Stack } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { TextInput } from "../ui/TextInput";
import { IconSearch } from "@tabler/icons-react";
import { useIsLaptopOrBigger } from "@/styles/useStyles";
import { UserProfileService } from "@/services/UserProfileService";
import { useUserIndustries } from "@/store/selectors/userProfileSelectors";
import { Analytics } from "@/services/Analytics";
import { useActivePlaylist } from "@/store/selectors/playlistSelectors";

export const PlaylistIndustrySelector = () => {
  const { industries } = useIndustryFilterOptions();
  const [search, setSearch] = useState("");
  const isLaptopOrBigger = useIsLaptopOrBigger();
  const userIndustries = useUserIndustries();
  const activePlaylist = useActivePlaylist();
  const filteredItems = useMemo(() => {
    return industries.filter((industry) =>
      industry.title.toLowerCase().includes(search.toLowerCase()),
    );
  }, [industries, search]);

  const handleSelectIndustry = (option: any) => {
    const alreadySelected = userIndustries?.[option.id];
    if (alreadySelected) {
      UserProfileService.removeIndustry({ id: option.id });
    } else {
      UserProfileService.addIndustry({
        id: option.id,
        title: option.label,
      });

      Analytics.updateUserProfile({
        action: "add_industry",
        label: option.label,
        playlist: activePlaylist,
      });
    }
  };

  useEffect(() => {
    // loop through user industries and if id is not in industries then remove it
    Object.keys(userIndustries).forEach((slug) => {
      if (!industries.some((s) => s.slug === slug)) {
        UserProfileService.removeIndustry({ id: slug });
      }
    });
  }, [industries, userIndustries]);

  return (
    <Stack align="center" w="100%">
      <TextInput
        id="partnerSearchInput"
        title="Search for industry"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search"
        size={isLaptopOrBigger ? "sm" : "md"}
        radius="xl"
        leftSection={<IconSearch size={18} />}
        maw={350}
        w="100%"
      />

      <Group justify="flex-start" gap="xs" maw={600}>
        {filteredItems.map((item) => (
          <FilterOptionChip
            key={item.slug}
            size={isLaptopOrBigger ? "sm" : "sm"}
            checked={userIndustries?.[item.slug]}
            tab={{
              value: "industry",
              filterKey: "industries",
              onClick: (option) => {
                handleSelectIndustry(option);
              },
            }}
            option={{ id: item.slug, label: item.title }}
            resourceConfig={ResourceConfigs.industry}
          />
        ))}
      </Group>
    </Stack>
  );
};
